import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 11,
  height: 11,
  viewboxWidth: 14,
  viewboxHeight: 14,
};

const XCloseIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M9.27751 8.09996C9.26423 8.08749 9.25364 8.07242 9.24641 8.05569C9.23917 8.03896 9.23544 8.02093 9.23544 8.0027C9.23544 7.98447 9.23917 7.96643 9.24641 7.9497C9.25364 7.93297 9.26423 7.91791 9.27751 7.90543L14.4207 2.75311C14.4987 2.67608 14.5605 2.58434 14.6027 2.48321C14.645 2.38208 14.6667 2.27356 14.6667 2.16396C14.6667 2.05435 14.645 1.94584 14.6027 1.8447C14.5605 1.74357 14.4987 1.65183 14.4207 1.5748C14.2638 1.42002 14.0523 1.33325 13.832 1.33325C13.6116 1.33325 13.4002 1.42002 13.2432 1.5748L8.10002 6.72156C8.08706 6.73501 8.07154 6.74571 8.05436 6.75302C8.03718 6.76032 8.01871 6.76409 8.00004 6.76409C7.98138 6.76409 7.9629 6.76032 7.94572 6.75302C7.92855 6.74571 7.91302 6.73501 7.90006 6.72156L2.75685 1.5748C2.59992 1.42002 2.38844 1.33325 2.1681 1.33325C1.94776 1.33325 1.73627 1.42002 1.57935 1.5748C1.50143 1.65183 1.43956 1.74357 1.39734 1.8447C1.35512 1.94584 1.33337 2.05435 1.33337 2.16396C1.33337 2.27356 1.35512 2.38208 1.39734 2.48321C1.43956 2.58434 1.50143 2.67608 1.57935 2.75311L6.72257 7.90543C6.73585 7.91791 6.74644 7.93297 6.75368 7.9497C6.76091 7.96643 6.76465 7.98447 6.76465 8.0027C6.76465 8.02093 6.76091 8.03896 6.75368 8.05569C6.74644 8.07242 6.73585 8.08749 6.72257 8.09996L1.57935 13.2467C1.50143 13.3238 1.43956 13.4155 1.39734 13.5166C1.35512 13.6178 1.33337 13.7263 1.33337 13.8359C1.33337 13.9455 1.35512 14.054 1.39734 14.1551C1.43956 14.2563 1.50143 14.348 1.57935 14.425C1.73627 14.5798 1.94776 14.6666 2.1681 14.6666C2.38844 14.6666 2.59992 14.5798 2.75685 14.425L7.90006 9.27827C7.91302 9.26483 7.92855 9.25413 7.94572 9.24682C7.9629 9.23951 7.98138 9.23575 8.00004 9.23575C8.01871 9.23575 8.03718 9.23951 8.05436 9.24682C8.07154 9.25413 8.08706 9.26483 8.10002 9.27827L13.2432 14.425C13.4002 14.5798 13.6116 14.6666 13.832 14.6666C14.0523 14.6666 14.2638 14.5798 14.4207 14.425C14.4987 14.348 14.5605 14.2563 14.6027 14.1551C14.645 14.054 14.6667 13.9455 14.6667 13.8359C14.6667 13.7263 14.645 13.6178 14.6027 13.5166C14.5605 13.4155 14.4987 13.3238 14.4207 13.2467L9.27751 8.09996Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default XCloseIcon;
